import { useState } from 'react';
import WeddingRequestAnswers from '../components/WeddingRequestAnswers';
import weddingRequestService from 'src/services/api/weddingRequestService';
import Swal from 'sweetalert2';

const FacilitateWeddingRequestAnswers = (props) => {
  const { answers, set_showWeddingRequestForm, getInfo, allWeddingFacilitators, inputs } = props;
  const [sending, set_sending] = useState(false);
  const [facilitator_editing, set_facilitator_editing] = useState(false);

  const editAnswerVars = (key, value) => {
    let facilitatorObservations = answers?.facilitatorObservations || {};
    if (key === 'approved') facilitatorObservations.approved = value;
    if (key === 'date') facilitatorObservations.date = value;

    let body = {
      id: answers?.id,
      male_guest_id: answers?.MaleGuest?.id,
      female_guest_id: answers?.FemaleGuest?.id,
      facilitator_guest_id: inputs?.Guest?.id,
      facilitatorObservations,
    };

    set_sending(true);
    weddingRequestService
      .WeddingFacilitatorEditRequest(body)
      .then((response) => {
        set_sending(false);
        if (response.data.success) {
          getInfo();
          set_facilitator_editing(false);
        }
      })
      .catch((error) => {
        set_sending(false);
        Swal.fire(error?.response?.data?.message);
      });
  };

  return (
    <WeddingRequestAnswers
      set_showWeddingRequestForm={set_showWeddingRequestForm}
      allWeddingFacilitators={allWeddingFacilitators}
      editAnswerVars={editAnswerVars}
      answers={answers}
      facilitator_editing={facilitator_editing}
      set_facilitator_editing={set_facilitator_editing}
      sending={sending}
      role={
        Number(inputs?.Guest?.id) === Number(answers?.facilitator_guest_id)
          ? 'facilitator'
          : 'guest'
      }
    />
  );
};

export default FacilitateWeddingRequestAnswers;
